import React from 'react';
import './ReportFullSessionMetricsSummary.css';

function MetricsRows({ metrics, t }) {
  return (
    <div className="report-metrics-summary-section report-metrics-summary-section--undivided">
      <div className="report-metrics-summary-row">
        <span className="report-metrics-summary-label">{t('report_metric_rq_ratio')}</span>
        <span className="report-metrics-summary-value">{metrics.R_Q_ratio?.toFixed(2) || 'N/A'}</span>
      </div>
      <div className="report-metrics-summary-row">
        <span className="report-metrics-summary-label">{t('report_metric_change_talk')}</span>
        <span className="report-metrics-summary-value">{metrics.percent_CT?.toFixed(1) || 'N/A'}%</span>
      </div>
      <div className="report-metrics-summary-row report-metrics-summary-row--last">
        <span className="report-metrics-summary-label">{t('report_metric_mi_consistent')}</span>
        <span className="report-metrics-summary-value">{metrics.percent_MIC?.toFixed(1) || 'N/A'}%</span>
      </div>
    </div>
  );
}

function SmokerMetricsRows({ smokerMetrics, t }) {
  return (
    <div className="report-metrics-summary-section">
      <h4>{t('report_client_validation_title')}</h4>
      <div className="report-metrics-summary-row">
        <span className="report-metrics-summary-label">{t('report_metric_first_change_talk')}</span>
        <span className="report-metrics-summary-value">{smokerMetrics.first_CT_volley ?? 'N/A'}</span>
      </div>
      <div className="report-metrics-summary-row">
        <span className="report-metrics-summary-label">{t('report_metric_avg_words')}</span>
        <span className="report-metrics-summary-value">{smokerMetrics.avg_words_per_client_utterance?.toFixed(1) || 'N/A'}</span>
      </div>
      <div className="report-metrics-summary-row report-metrics-summary-row--last">
        <span className="report-metrics-summary-label">{t('report_metric_first_smoking')}</span>
        <span className="report-metrics-summary-value">{smokerMetrics.first_smoking_mention_volley ?? 'N/A'}</span>
      </div>
    </div>
  );
}

function EndReason({ endReason, t }) {
  if (!endReason) return null;
  return (
    <div className="end-reason-section">
      <span className="end-reason-label">{t('report_session_end_reason')}</span>
      <p className="end-reason-text">{endReason}</p>
    </div>
  );
}

function ReportFullSessionMetricsSummary({ t, metrics, smokerMetrics, endReason }) {
  return (
    <div className="report-metrics-summary-panel">
      <div className="analytics-header">
        <div className="analytics-header-row">
          <div className="analytics-header-copy">
            <h4 className="analytics-title">{t('report_session_metrics_title')}</h4>
          </div>
        </div>
        <div className="analytics-header-divider" aria-hidden="true" />
      </div>
      <div className="report-metrics-summary-content">
        {metrics && <MetricsRows metrics={metrics} t={t} />}
        {smokerMetrics && <SmokerMetricsRows smokerMetrics={smokerMetrics} t={t} />}
        <EndReason endReason={endReason} t={t} />
      </div>
    </div>
  );
}

export default ReportFullSessionMetricsSummary;
